import React, { useState } from "react";

import { Formik, Form } from "formik";
import { RightMinimalArrow } from "icons";

import fhirApi from "apis/fhir";
import {
  Accordion,
  Button,
  Pane,
  Steps,
  Typography,
} from "clearsense-ui/components";
import { Select, Textarea } from "clearsense-ui/components/formik";

import FormatReference from "./FormatReference";

import {
  CONVERSION_DATA_VALIDATION,
  CONVERSION_TYPE,
  FORMAT_REFERENCE,
  TEMPLATE_COLLECTION_REFERENCE,
  ROOT_TEMPLATE,
} from "../../constants";

const ConversionData = ({
  selectedConverter,
  handleCancel,
  setSelectedConverter,
  fhirDetails,
  onClose,
}) => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async values => {
    try {
      const payload = {
        inputData: values.conversionData,
        inputDataType: selectedConverter.value,
        templateCollectionReference:
          TEMPLATE_COLLECTION_REFERENCE[selectedConverter.value],
        rootTemplate: ROOT_TEMPLATE[selectedConverter.value],
      };
      const response = await fhirApi.convertData(payload);
      const conversionStatus = response.success === true ? 1 : 0;
      await fhirApi.create({
        ...fhirDetails,
        data: values.conversionData,
        response: response.data,
        status: conversionStatus,
      });
    } catch (e) {
      logger.error(e);
    } finally {
      onClose();
    }
  };

  const downloadFormatReference = () => {
    const element = document.createElement("a");
    const file = new Blob([JSON.stringify(FORMAT_REFERENCE)]);
    element.href = URL.createObjectURL(file);
    element.download = `Format Reference ${selectedConverter.value}.txt`;
    document.body.appendChild(element);
    element.click();
  };

  return (
    <Formik
      initialValues={{
        conversionType: selectedConverter,
        conversionData: "",
      }}
      validationSchema={CONVERSION_DATA_VALIDATION}
      onSubmit={handleSubmit}
      validateOnBlur={submitted}
      validateOnChange={submitted}
      enableReinitialize
    >
      {({ isSubmitting }) => (
        <Form>
          <Pane.Body className="py-2 space-y-2 overflow-auto">
            <Typography style="h5">
              Select a converter and convert non-compliant data to FHIR.
            </Typography>
            <Steps
              className="mt-8"
              currentStep={2}
              steps={[
                <Typography key="categories">Select converter</Typography>,
                <Typography key="database_type">
                  Enter Data for Conversion
                </Typography>,
              ]}
            />
            <div className="w-full space-y-4">
              <Select
                label="Conversion Type"
                placeholder="Select conversion type"
                name="conversionType"
                size="small"
                options={CONVERSION_TYPE}
                strategy="fixed"
                value={selectedConverter}
                onChange={value => setSelectedConverter(value)}
                required
              />
              <Textarea
                name="conversionData"
                label={`Enter ${selectedConverter.value} Data for Conversion`}
                placeholder={`Enter data in ${selectedConverter.value} format`}
                required
              />
              <Accordion>
                <Accordion.Item
                  title={
                    <Typography type="semibold">
                      Format Reference for {selectedConverter.value}
                    </Typography>
                  }
                  actionProps={{ className: "mr-2" }}
                >
                  <div className="flex-col space-y-4">
                    <FormatReference />
                    <Button
                      className="text-sm text-indigo-700"
                      size="small"
                      onClick={downloadFormatReference}
                      label="Download Sample Format Template"
                      style="text"
                    />
                  </div>
                </Accordion.Item>
              </Accordion>
            </div>
          </Pane.Body>
          <Pane.Footer>
            <div className="flex items-end w-full">
              <Button
                label="Convert To FHIR"
                icon={RightMinimalArrow}
                iconPosition="right"
                loading={isSubmitting}
                disabled={isSubmitting}
                size="large"
                type="submit"
                onClick={() => setSubmitted(true)}
              />
              <Button
                label="Cancel"
                style="text"
                size="large"
                onClick={handleCancel}
              />
            </div>
          </Pane.Footer>
        </Form>
      )}
    </Formik>
  );
};

export default ConversionData;
